import { InternalException } from "@amzn/piezo-plenum-types";
import init, { execute_wasm_operation, decode_base64 } from "@amzn/amzn-piezo-plenum-wasm";
export class PiezoPlenumClient {
    logLevel;
    constructor(props = {}) {
        this.logLevel = props.logLevel?.toUpperCase() ?? 'INFO';
    }
    static async initialize(logLevel) {
        await init();
        return new PiezoPlenumClient({ logLevel });
    }
    async executeOperation(operation, input, key) {
        console.debug(`Executing operation ${operation} with input ${input}`);
        const output = await execute_wasm_operation(operation, JSON.stringify(input), this.logLevel, key);
        try {
            return JSON.parse(output);
        }
        catch (err) {
            throw new InternalException({
                message: `Failed to deserialize FFI output: ${err}`,
                $metadata: {}
            });
        }
    }
    async createPlenumDocument(input, key) {
        return await this.executeOperation("CreatePlenumDocument", input, key);
    }
    async parsePlenumDocument(input, key) {
        return await this.executeOperation("ParsePlenumDocument", input, key);
    }
    async signPlenumDocument(input, key) {
        return await this.executeOperation("SignPlenumDocument", input, key);
    }
    async mergePlenumDocument(input, key) {
        return await this.executeOperation("MergePlenumDocument", input, key);
    }
    async createPiezoFrame(input, key) {
        return await this.executeOperation("CreatePiezoFrame", input, key);
    }
    async createPiezoRequest(input, key) {
        return await this.executeOperation("CreatePiezoRequest", input, key);
    }
    async createActionDocuments(input, key) {
        return await this.executeOperation("CreateActionDocuments", input, key);
    }
    async approveAction(input, key) {
        return await this.executeOperation("ApproveAction", input, key);
    }
    async filterPermits(input, key) {
        return await this.executeOperation("FilterPermits", input, key);
    }
    async createRegisterIdentityDocument(input, key) {
        return await this.executeOperation("CreateRegisterIdentityDocument", input, key);
    }
    decodePlenumDocument(encoded) {
        return decode_base64(encoded);
    }
}
